export class InvatationNotFoundError extends Error {
  constructor(projectInvitationId: string) {
    super(`Project invitation with id - ${projectInvitationId} not found `)
  }
}